export class BaseError extends Error {
    constructor(message, reason) {
        super(message);
        this.name = 'BaseError';
        this.reason = reason;
    }
}
// TODO narrow types and add explicit reason values
export class OpenError extends BaseError {
    constructor() {
        super(...arguments);
        this.name = 'OpenError';
    }
}
export class TxReceiptError extends BaseError {
    constructor() {
        super(...arguments);
        this.name = 'TxReceiptError';
    }
}
export class GetOrderError extends BaseError {
    constructor() {
        super(...arguments);
        this.name = 'GetOrderError';
    }
}
export class WatchDidFillError extends BaseError {
    constructor() {
        super(...arguments);
        this.name = 'WatchDidFillError';
    }
}
export class DidFillError extends BaseError {
    constructor() {
        super(...arguments);
        this.name = 'DidFillError';
    }
}
export class ValidateOrderError extends BaseError {
    constructor() {
        super(...arguments);
        this.name = 'ValidateOrderError';
    }
}
export class ParseOpenEventError extends BaseError {
    constructor() {
        super(...arguments);
        this.name = 'ParseOpenEventError';
    }
}
export class LoadContractsError extends BaseError {
    constructor() {
        super(...arguments);
        this.name = 'LoadContractsError';
    }
}
export class AccountRequiredError extends BaseError {
    constructor() {
        super(...arguments);
        this.name = 'AccountRequiredError';
    }
}
export class AbortError extends BaseError {
    constructor() {
        super(...arguments);
        this.name = 'AbortError';
    }
}
//# sourceMappingURL=base.js.map